"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleStyled = exports.modifiers = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
exports.modifiers = {
  xLarge: function xLarge() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(80) + "line-height: 1.25;"
    };
  },
  small: function small() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(45)
    };
  },
  xSmall: function xSmall() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(24) + "line-height: 1.25;"
    };
  },
  xxSmall: function xxSmall() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(14) + "line-height: normal; letter-spacing: 0.5px;"
    };
  },
  tiny: function tiny() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(14) + "line-height: normal; letter-spacing: normal;"
    };
  },
  secondary: function secondary() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(48) + "line-height: 1.25;"
    };
  },
  secondarySmall: function secondarySmall() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(36) + "line-height: 1.25;"
    };
  },
  secondaryLarge: function secondaryLarge() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(65)
    };
  },
  tertiary: function tertiary() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(37)
    };
  },
  tertiaryXSmall: function tertiaryXSmall() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(18) + 'line-height: 1.25; letter-spacing: 0.15em;'
    };
  },
  tertiaryXXSmall: function tertiaryXXSmall() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(16) + 'line-height: 1.25; letter-spacing: 0.15em;'
    };
  },
  tertiarySmall: function tertiarySmall() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(28) + 'line-height: 1.25;'
    };
  },
  tertiaryLarge: function tertiaryLarge() {
    return {
      styles: (0, atoms_utils_theme_1.fontSize)(50)
    };
  },
  inverted: function inverted(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.gray_3, ";\n    ")
    };
  },
  brandColor: function brandColor(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.brand_primary, ";\n    ")
    };
  },
  lineHeightNormal: function lineHeightNormal() {
    return {
      styles: "\n    line-height: normal;\n  "
    };
  },
  lineHeightSmall: function lineHeightSmall() {
    return {
      styles: "\n    line-height: 1;\n  "
    };
  },
  letterSpaceSmall: function letterSpaceSmall() {
    return {
      styles: "\n    letter-spacing: 0.5px;\n  "
    };
  },
  semiBold: function semiBold() {
    return {
      styles: "\n      font-weight: 500;\n    "
    };
  },
  bold: function bold() {
    return {
      styles: "\n      font-weight: 700;\n    "
    };
  },
  left: function left() {
    return {
      styles: "text-align: left;"
    };
  },
  right: function right() {
    return {
      styles: "text-align: right;"
    };
  },
  center: function center() {
    return {
      styles: "text-align: center;"
    };
  },
  marginBottomSmall: function marginBottomSmall() {
    return {
      styles: "margin: 0 0 1.5rem;"
    };
  }
};
exports.TitleStyled = styled_components_1.default.h1.attrs({
  className: 'Title'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  ", ";\n  font-weight: 300;\n  line-height: 4.6875rem;\n  letter-spacing: 0.2rem;\n  color: ", ";\n  padding: 0;\n  margin: 0;\n\n  @media (min-width: ", ") {\n    letter-spacing: 0.5rem;\n  }\n\n  ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.farmProject.font_family;
}, (0, atoms_utils_theme_1.fontSize)(60), function (_ref4) {
  var theme = _ref4.theme;
  return theme.farmProject.dark_gray;
}, atoms_utils_theme_1.breakPoints.medium_break, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));